<div class="container">

  <div class="row justify-content-center">
    <div class="col-auto">
      <mat-form-field class="mt-1">
        <mat-label>Meses</mat-label>
        <mat-select multiple [ngModel]="monthsSelected"
          (selectionChange)="onChangeMonth($event)" #monthSelect>
          <mat-checkbox (change)='onSelectAll($event)' class="ps-3" [(ngModel)]="allMonthsSelected">
            Todos
          </mat-checkbox>
          <mat-option *ngFor="let card of monthList; trackBy: trackByIndex" [value]="card.number">{{card.name}}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </div>

  <ng-container *ngIf="requestReady === false">
    <div class="row">
      <div class="col">
        <div class="cf-dlg-loading"><div class="cf-dlg-loading__dots"><span></span><span></span><span></span></div></div>
      </div>
    </div>
  </ng-container>

  <ng-container *ngIf="requestReady === true">
    <div class="cf-chart-grid cf-chart-grid--even">

      <!-- Cliente al que mas vendo -->
      <div class="cf-chart-card">
        <div class="cf-chart-card__header">
          <div class="cf-chart-card__icon cf-chart-card__icon--green">
            <mat-icon>show_chart</mat-icon>
          </div>
          <div class="cf-chart-card__title-wrap">
            <p class="cf-chart-card__title">Clientes a los que más vendo</p>
            <p class="cf-chart-card__sub">Total vendido por cliente</p>
          </div>
        </div>
        <div class="cf-chart-canvas-wrap">
          <canvas baseChart
            [type]="chartType"
            [data]="chartDataCustomersISellToTheMost"
            [options]="chartOptionsCustomersISellToTheMost">
          </canvas>
        </div>
      </div>

      <!-- Clientes que mas deben -->
      <div class="cf-chart-card">
        <div class="cf-chart-card__header">
          <div class="cf-chart-card__icon">
            <mat-icon>schedule</mat-icon>
          </div>
          <div class="cf-chart-card__title-wrap">
            <p class="cf-chart-card__title">Clientes que más deben</p>
            <p class="cf-chart-card__sub">Saldo pendiente de cobro por cliente</p>
          </div>
        </div>
        <div class="cf-chart-canvas-wrap">
          <canvas baseChart
            [type]="chartType"
            [data]="chartDataCustomersWhoOwe"
            [options]="chartOptionsCustomersWhoOwe">
          </canvas>
        </div>
      </div>

    </div>
  </ng-container>

</div>
